import { render } from "./PingResult.vue?vue&type=template&id=a4a6ff96&scoped=true"
import script from "./PingResult.vue?vue&type=script&lang=js"
export * from "./PingResult.vue?vue&type=script&lang=js"

import "./PingResult.vue?vue&type=style&index=0&id=a4a6ff96&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4a6ff96"]])

export default __exports__